import React, { useState, useEffect } from "react";
import { RocketButton } from "../../assets/images";
import { Logo, Hamburger, Smiley } from "../../assets";
import {
  authWrapper,
  landingMainWrapper,
  landingStartWrapper,
  landingHeaderWrapper,
  desktopStart,
  rocketButtonEle,
  appCloseWrapDeskTop,
  appCloseText,
  appCloseWrapMobile,
  appCloseTextMobile,
  landingLogo,
} from "./layout.module.css";
import { Link } from "react-router-dom";
import { Loader } from "../../components";
import axios from "axios";
import { EndPoints } from "../../api";

const LandingLayout = ({ children }) => {
  const [applicationClose, setApplicationClose] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(true);
    axios
      .get(EndPoints.main)
      .then((res) => {
        setLoader(false);

        setApplicationClose(res.data?.data?.user_application_closed);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoader(false);
      });
  }, []);

  return (
    <>
      {loader && <Loader />}
      <div className={authWrapper}>
        <header className={landingHeaderWrapper}>
          <Logo className={landingLogo} />
          {applicationClose ? (
            <div className={appCloseWrapDeskTop}>
              <Smiley />
              <h6 className={appCloseText}>
                Applications closed for the year.
              </h6>
            </div>
          ) : null}

          <Link
            className={desktopStart}
            to="/login"
            style={{ textDecoration: "none" }}
          >
            <div className={landingStartWrapper}>
              <p>Login</p>
              <img
                className={rocketButtonEle}
                src={RocketButton}
                alt="rcoket Button Icon"
              />
            </div>
          </Link>

          {applicationClose ? (
            <div className={appCloseWrapMobile}>
              <h6 className={appCloseTextMobile}>Applications closed</h6>
            </div>
          ) : null}
        </header>
        <div className={landingMainWrapper}>
          <div>{children}</div>
        </div>
      </div>
    </>
  );
};

export { LandingLayout };
